"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpanderDefaultProps = exports.ExpanderContentDefaultProps = exports.TITLE_HORIZONTAL_SPACING = void 0;
var TITLE_HORIZONTAL_SPACING = 24;
exports.TITLE_HORIZONTAL_SPACING = TITLE_HORIZONTAL_SPACING;
var ExpanderContentDefaultProps = {
  spacingTop: 0,
  isExpanded: false
};
exports.ExpanderContentDefaultProps = ExpanderContentDefaultProps;
var ExpanderDefaultProps = {
  shouldExpandOnMount: false,
  contentSpacing: 'S300',
  shouldVisuallyHideTriggerText: false
};
exports.ExpanderDefaultProps = ExpanderDefaultProps;